import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import { About } from '../views/about'
import { Home } from '../views/home'
import { Navigator } from '../views/navigator'
import vuetify from '../plugins/vuetify';

Vue.use(vuetify)
Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    component: About
  },
  {
    path: '/navigator/:specindex',
    name: 'Navigator',
    component: Navigator
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
